function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z",
  stroke: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.679 23.679C23.8911 23.4669 24.2204 23.4433 24.4586 23.6083L24.5432 23.679L34.321 33.4568C34.5597 33.6954 34.5597 34.0824 34.321 34.321C34.1089 34.5331 33.7796 34.5567 33.5414 34.3917L33.4568 34.321L23.679 24.5432C23.4403 24.3046 23.4403 23.9176 23.679 23.679Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4568 23.679C33.6954 23.4403 34.0824 23.4403 34.321 23.679C34.5331 23.8911 34.5567 24.2204 34.3917 24.4586L34.321 24.5432L24.5432 34.321C24.3046 34.5597 23.9176 34.5597 23.679 34.321C23.4669 34.1089 23.4433 33.7796 23.6083 33.5414L23.679 33.4568L33.4568 23.679Z",
  fill: "currentColor"
});

var SvgUnsuccessful = function SvgUnsuccessful(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 58",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnsuccessful, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unsuccessful.efd06ed7.svg";
export { ForwardRef as ReactComponent };